import { IOrganizationMap, OrganizationMap } from "../organization-map";

export interface IInfoMarker {
  position: google.maps.LatLngLiteral;
  title: string;
  content: HTMLElement;
  item: any;
}

export interface IOrganizationInfoMarker extends IInfoMarker {
  item: IOrganizationMap
}

export class OrganizationInfoMarker implements IOrganizationInfoMarker {
  position: google.maps.LatLngLiteral;
  title: string;
  content: HTMLElement;
  item: OrganizationMap;

  constructor(data: IOrganizationInfoMarker) {
    this.position = data.position;
    this.title = data.title;
    this.content = data.content;
    this.item = new OrganizationMap(data.item);
  }
}
